/**
 * Direct utility function to add prize to balance
 * This function bypasses the regular balance update mechanism
 * to ensure prizes are properly added to the user's balance
 */

// Helper to convert prize value string to number (e.g., '5K' to 5000)
export const convertPrizeToNumber = (prizeString) => {
  if (!prizeString) return 0;
  
  console.log(`Converting prize string: ${prizeString}`);
  
  let result = 0;
  if (typeof prizeString === 'string' && prizeString.includes('K')) {
    result = parseInt(prizeString.replace('K', '')) * 1000;
  } else {
    // Handle both string and number inputs
    result = Number(prizeString) || 0;
  }
  
  console.log(`Converted prize value: ${result}`);
  return result;
};

// Direct function to add prize to balance
export const addPrizeToBalance = (prizeValue, addToBalance, setLocalBalance, toast) => {
  console.log('🔍 addPrizeToBalance called with:', { 
    prizeValue, 
    addToBalanceFunction: !!addToBalance, 
    setLocalBalanceFunction: !!setLocalBalance,
    toastFunction: !!toast 
  });
  
  // Check if all required parameters are provided
  if (!addToBalance || !setLocalBalance || !toast) {
    console.error('❌ MISSING REQUIRED FUNCTIONS:', { 
      addToBalance: !!addToBalance, 
      setLocalBalance: !!setLocalBalance, 
      toast: !!toast 
    });
    console.error('Error adding prize to balance: Missing required functions');
    return;
  }
  
  // Convert prize to number and ensure it's a valid number
  const prize = convertPrizeToNumber(prizeValue);
  if (isNaN(prize) || prize <= 0) {
    console.error(`❌ Invalid prize value: ${prizeValue}, converted to ${prize}`);
    return;
  }
  
  console.log(`🏆 ADDING PRIZE: ${prize} JINU from prize ${prizeValue}`);
  
  // Update local state immediately
  try {
    setLocalBalance(prevBalance => {
      console.log(`🔄 Local balance update attempt: ${prevBalance} + ${prize}`);
      const newBalance = prevBalance + prize;
      console.log(`✅ Local balance updated: ${prevBalance} + ${prize} = ${newBalance}`);
      return newBalance;
    });
  } catch (error) {
    console.error('❌ Error updating local balance:', error);
  }
  
  // Update global balance directly
  try {
    // Use the context function directly with a forced number
    console.log(`🔄 Attempting to update global balance with: 'jinu', ${Number(prize)}`);
    addToBalance('jinu', Number(prize));
    console.log(`✅ Global balance updated with prize: ${prize} JINU`);
    
    // Show success toast
    toast({
      title: "Prize Won!",
      description: `${prize} JINU added to your balance!`,
      status: "success",
      duration: 3000,
      isClosable: true
    });
    
    // No alert needed - toast notification is sufficient
  } catch (error) {
    console.error('❌ Error updating global balance:', error);
    // Show error in toast instead of alert
    toast({
      title: "Error Adding Prize",
      description: `There was a problem adding your prize: ${error.message}`,
      status: "error",
      duration: 5000,
      isClosable: true
    });
  }
};
